var _g, _path, _g2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUniversal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 133,
    viewBox: "0 0 128 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_665_5872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.4811 31H52.0542C50.4066 31 49.0771 32.3365 49.0771 33.977V57.9277C49.0771 59.5753 50.4136 60.9047 52.0542 60.9047H56.5162V67.5376C56.5162 69.5176 58.9063 70.5076 60.3065 69.1075L68.5092 60.9047H92.4811C94.1287 60.9047 95.4581 59.5682 95.4581 57.9277V33.977C95.4581 32.3294 94.1216 31 92.4811 31Z",
    fill: "#EF4444"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.4811 31H52.0542C50.4066 31 49.0771 32.3365 49.0771 33.977V57.9277C49.0771 59.5753 50.4136 60.9047 52.0542 60.9047H56.5162V67.5376C56.5162 69.5176 58.9063 70.5076 60.3065 69.1075L68.5092 60.9047H92.4811C94.1287 60.9047 95.4581 59.5682 95.4581 57.9277V33.977C95.4581 32.3294 94.1216 31 92.4811 31Z",
    fill: "#EF4444"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_665_5872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.451 41.8691H38.3783C34.8568 41.8691 32 44.726 32 48.2404V101.629C32 105.151 34.8568 108 38.3783 108H71.451C74.9726 108 77.8294 105.151 77.8294 101.629V48.2404C77.8294 44.726 74.9726 41.8691 71.451 41.8691ZM68.8771 103.418C68.6154 103.68 68.2477 103.842 67.8517 103.842H41.9777C41.1786 103.842 40.528 103.199 40.528 102.4C40.528 102.004 40.6907 101.636 40.9523 101.375C41.2139 101.113 41.5746 100.95 41.9777 100.95H67.8517C68.6508 100.95 69.3014 101.601 69.3014 102.4C69.3014 102.796 69.1387 103.164 68.8771 103.418Z",
    fill: "url(#paint0_linear_665_5872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3783 42.0459H71.451C74.8751 42.0459 77.6526 44.8237 77.6526 48.2404V101.629C77.6526 105.053 74.8752 107.824 71.451 107.824H38.3783C34.9542 107.824 32.1768 105.053 32.1768 101.629V48.2404C32.1768 44.8237 34.9543 42.0459 38.3783 42.0459ZM67.8517 104.019C68.2957 104.019 68.7076 103.837 69.0012 103.544C69.2963 103.256 69.4781 102.843 69.4781 102.4C69.4781 101.503 68.7484 100.773 67.8517 100.773H41.9777C41.5257 100.773 41.1207 100.956 40.8273 101.25C40.5336 101.543 40.3513 101.955 40.3513 102.4C40.3513 103.298 41.0821 104.019 41.9777 104.019H67.8517Z",
    stroke: "url(#paint1_linear_665_5872)",
    strokeWidth: 0.353567
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3007 102.399C69.3007 102.795 69.138 103.163 68.8764 103.417C68.6147 103.679 68.247 103.841 67.851 103.841H41.977C41.1779 103.841 40.5273 103.198 40.5273 102.399C40.5273 102.003 40.69 101.635 40.9516 101.373C41.2132 101.112 41.5739 100.949 41.977 100.949H67.851C68.6501 100.949 69.3007 101.6 69.3007 102.399Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_665_5872",
    x: 18.6704,
    y: 0.593204,
    width: 107.194,
    height: 99.5773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.2034,
    result: "effect1_foregroundBlur_665_5872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_665_5872",
    x: 19.2716,
    y: 29.1407,
    width: 71.2864,
    height: 91.5877,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.36421
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_665_5872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_665_5872",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_665_5872",
    x1: 34.5873,
    y1: 104.267,
    x2: 89.5166,
    y2: 66.2006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_665_5872",
    x1: 35.235,
    y1: 47.0702,
    x2: 88.2389,
    y2: 86.3453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversal);
export default __webpack_public_path__ + "static/media/universal.cfe744bc7b705186fc454603e07388fe.svg";
export { ForwardRef as ReactComponent };